(function initPortraitHeroVideo() {
    const triggers = document.querySelectorAll('[data-portrait-hero-video-trigger]');
    const modal = document.getElementById('portraitHeroVideoModal');
    const video = document.getElementById('portraitHeroVideoPlayer');
    const embed = document.getElementById('portraitHeroVideoEmbed');
    const closeTriggers = document.querySelectorAll('[data-portrait-hero-video-close]');

    if (!triggers.length || !modal || !video || !embed) {
        return;
    }

    function getYouTubeEmbedUrl(src) {
        if (!src) {
            return '';
        }

        let url;

        try {
            url = new URL(src, window.location.origin);
        } catch (error) {
            return '';
        }

        const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
        let videoId = '';

        if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
            if (url.pathname === '/watch') {
                videoId = url.searchParams.get('v') || '';
            } else if (url.pathname.startsWith('/embed/') || url.pathname.startsWith('/shorts/')) {
                videoId = url.pathname.split('/')[2] || '';
            }
        } else if (hostname === 'youtu.be') {
            videoId = url.pathname.split('/').filter(Boolean)[0] || '';
        }

        if (!videoId) {
            return '';
        }

        const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
        embedUrl.searchParams.set('autoplay', '1');
        embedUrl.searchParams.set('rel', '0');

        return embedUrl.toString();
    }

    function resetPlayers() {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.hidden = true;

        embed.removeAttribute('src');
        embed.hidden = true;
    }

    function openVideo(src) {
        if (!src) {
            return;
        }

        const youtubeEmbedUrl = getYouTubeEmbedUrl(src);

        resetPlayers();

        if (youtubeEmbedUrl) {
            embed.src = youtubeEmbedUrl;
            embed.hidden = false;
        } else {
            video.src = src;
            video.hidden = false;
        }

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        if (youtubeEmbedUrl) {
            return;
        }

        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => { });
        }
    }

    function closeVideo() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        resetPlayers();
    }

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            openVideo(trigger.getAttribute('data-video-src'));
        });

        trigger.addEventListener('keydown', (event) => {
            if (trigger.tagName === 'BUTTON') {
                return;
            }

            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }

            event.preventDefault();
            openVideo(trigger.getAttribute('data-video-src'));
        });
    });

    closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', closeVideo);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeVideo();
        }
    });
}());
